import { withAppCrashIfException } from 'epic';
import { advisoryEpic } from 'epic/advisory';
import { batchWorkspaceEpic } from 'epic/batchWorkspace';
import { blotterEpics } from 'epic/blotters';
import { secondaryMarketTradeBlotterEpic } from 'epic/blotters/secondaryMarketTradeBlotter';
import { commonFormEpic } from 'epic/common-form';
import { correlationGraphEpic } from 'epic/correlationGraphEpic';
import { dashboardEpic } from 'epic/dashboard';
import { emailServiceEpic } from 'epic/emailService';
import { essentialFormEpic } from 'epic/essential-form';
import { quoteLoadingEpic } from 'epic/loadQuote';
import { missedDealFeedbackEpic } from 'epic/missed-deal-feedback';
import { dynamicFormEpic } from 'epic/newDynamicForm';
import { notificationEpic } from 'epic/notification';
import { postTradeOperationsEpics } from 'epic/postTradeOperations';
import { priceImprovementEpic } from 'epic/priceImprovement';
import { productDescriptionsEpic } from 'epic/productDescriptions';
import { scheduledRunEpic } from 'epic/scheduledRuns';
import { secondaryMarketEpic } from 'epic/secondaryMarket';
import { smartQuoteEpic } from 'epic/smart-quote';
import { staticFormEpic } from 'epic/static-form';
import { streamingQuoteEpic } from 'epic/streamingQuote';
import { underlyingsHistoricsEpic } from 'epic/underlyingHistoGraph';
import { analyticsEpics } from 'epic/userConsent';
import { userPreferencesEpics } from 'epic/userPreferences';
import { workspaceCommonEpic } from 'epic/workspace/common';
import { essentialWorkspaceEpic } from 'epic/workspace/essential';
import { ordersBasketEpic } from 'epic/workspace/ordersBasket';
import { combineEpics } from 'redux-observable';
import { logAnalytics } from 'shared/middlewares/analytics/logger';

import { secondaryMarketOrderBlotterEpic } from '../../epic/blotters/secondaryMarketOrderBlotter';
import unhandledErrorEpic from './unhandledErrorEpic';

const combinedEpics = combineEpics(
  essentialFormEpic(),
  advisoryEpic(),
  analyticsEpics(logAnalytics),
  blotterEpics(),
  commonFormEpic(),
  dashboardEpic(),
  dynamicFormEpic(),
  streamingQuoteEpic(),
  ordersBasketEpic(),
  correlationGraphEpic(),
  missedDealFeedbackEpic(),
  batchWorkspaceEpic(),
  notificationEpic(),
  postTradeOperationsEpics(),
  priceImprovementEpic(),
  productDescriptionsEpic(),
  quoteLoadingEpic(),
  secondaryMarketEpic(),
  secondaryMarketOrderBlotterEpic(),
  secondaryMarketTradeBlotterEpic(),
  staticFormEpic(),
  unhandledErrorEpic(),
  userPreferencesEpics(),
  workspaceCommonEpic(),
  emailServiceEpic(),
  underlyingsHistoricsEpic(),
  scheduledRunEpic(),
  essentialWorkspaceEpic(),
  smartQuoteEpic(),
);
export default function rootEpic(shouldWithAppCrashIfException: boolean = true) {
  return shouldWithAppCrashIfException ? withAppCrashIfException('root', combinedEpics) : combinedEpics;
}
